import React from 'react';
import LoadingButton from './LoadingButton';

const Button = ({ to, className, disabled, ...rest }) => (
  <LoadingButton className={className} component={to ? 'div' : 'button'} disabled={disabled} {...rest} />
);

export default Button;
